import React, { useState } from "react";
import { URLS } from "../urls";
import DisplayUsers from "./DisplayUsers";

const DisplayCustomPolicy = ({
  leave,
  showMoreAssignees,
  updateCustomPolicySelectedLeave,
  showLessAssignees,
  showAllAssignees,
  updateEditCustomPolicy,
  updateDeleteCustomPolicy,
  updateLeaveAndCustom,
}) => {
  const [open, setOpen] = useState(false);
  const [users, setUsers] = useState([]);

  const showUser = ({ image, name }) => {
    return (
      <div
        style={{
          display: "inline-block",
          textAlign: "center",
          marginRight: "10px",
        }}
      >
        <div
          style={{
            display: "inline",
          }}
        >
          <span className="avatar">
            <img
              alt=""
              src={
                image
                  ? URLS.backendStatic + "/" + image
                  : "/assets/img/profiles/avatar-02.jpg"
              }
            />
          </span>
        </div>
        <div>
          <span>{name}</span>
        </div>
      </div>
    );
  };

  return (
    <div className="custom-policy">
      <div className="leave-header">
        <div className="title">
          <b>Custom policy</b>
        </div>
        <div>
          <button
            className="btn btn-sm add-btn"
            type="button"
            data-toggle="modal"
            data-target="#add_custom_policy"
            onClick={updateCustomPolicySelectedLeave(leave)}
            disabled={leave.isActive ? true : false}
          >
            <i className="fa fa-plus"></i> Add custom policy
          </button>
        </div>
      </div>
      <div className="table-responsive">
        <table className="table table-hover table-nowrap leave-table">
          <thead>
            <tr>
              <th className="l-name">Name</th>
              <th className="l-days">Days</th>
              <th className="l-assignee">Assignee</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {leave?.customPolicies && leave?.customPolicies?.length > 0
              ? leave.customPolicies.map((lcp) => {
                  return (
                    <tr>
                      <td>{lcp.name}</td>
                      <td>{lcp.days}</td>
                      {lcp["assignees"] && lcp["assignees"].length ? (
                        lcp.assignees.length < 3 ? (
                          <td>
                            {lcp.assignees.map((assignee) => {
                              return (
                                <>
                                  {showUser({
                                    image: assignee.image,
                                    name: assignee.name,
                                  })}
                                </>
                              );
                            })}
                          </td>
                        ) : showMoreAssignees[leave?._id][lcp?._id] ? (
                          <td
                            style={{
                              whiteSpace: "normal",
                            }}
                          >
                            {lcp.assignees.map((assignee) => {
                              return (
                                <>
                                  {showUser({
                                    image: assignee.image,
                                    name: assignee.name,
                                  })}
                                </>
                              );
                            })}

                            <span
                              onClick={showLessAssignees(leave._id, lcp._id)}
                              className="border border-dark px-2 rounded p-cursor"
                            >
                              Less
                            </span>
                          </td>
                        ) : (
                          <td>
                            <>
                              {showUser({
                                image: lcp.assignees[0].image,
                                name: lcp.assignees[0].name,
                              })}
                            </>
                            <>
                              {showUser({
                                image: lcp.assignees[1].image,
                                name: lcp.assignees[1].name,
                              })}
                            </>

                            <span
                              onClick={() => {
                                if (leave.prorated) {
                                  setUsers(lcp.assignees);
                                  setOpen(true);
                                } else {
                                  showAllAssignees(leave._id, lcp._id)();
                                }
                              }}
                              className="border border-dark px-2 rounded p-cursor"
                            >
                              +{lcp.assignees.length - 2}
                            </span>
                          </td>
                        )
                      ) : (
                        <td></td>
                      )}
                      <td className="text-right">
                        <div className="dropdown dropdown-action">
                          <span
                            aria-expanded="false"
                            data-toggle="dropdown"
                            className="action-icon dropdown-toggle p-cursor"
                          >
                            <i className="material-icons">more_vert</i>
                          </span>
                          <div className="dropdown-menu dropdown-menu-right">
                            <span
                              className="dropdown-item p-cursor"
                              data-toggle="modal"
                              data-target="#edit_custom_policy"
                              onClick={updateEditCustomPolicy(lcp)}
                            >
                              <i className="fa fa-pencil m-r-5"></i> Edit
                            </span>
                            <span
                              className="dropdown-item p-cursor"
                              data-toggle="modal"
                              data-target="#add_leave_allowance"
                              onClick={() => {
                                updateLeaveAndCustom({ leave, lcp });
                              }}
                            >
                              <i className="fa fa-money m-r-5"></i> Add
                              Allowance
                            </span>

                            <span
                              className="dropdown-item p-cursor"
                              data-toggle="modal"
                              data-target="#delete_custom_policy"
                              onClick={updateDeleteCustomPolicy(lcp)}
                            >
                              <i className="fa fa-trash-o m-r-5"></i> Delete
                            </span>
                          </div>
                        </div>
                      </td>
                    </tr>
                  );
                })
              : ""}
          </tbody>
        </table>
      </div>

      {open ? (
        <DisplayUsers
          users={users}
          open={open}
          close={() => setOpen(false)}
          leave={leave}
        />
      ) : null}
    </div>
  );
};

export default DisplayCustomPolicy;
